import { BID_UNIT_POLICIES } from "../assets/variables/constants";

export const getPriceUnit = (current = 0) => {
    const man = 10000;
    return BID_UNIT_POLICIES.find(({ test }) => test(current))?.value || 1000 * man;
};
